import PageBanner from 'components/Luxkit/Banners/PageBanner'
import TextLink from 'components/Luxkit/TextLink'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import config from 'constants/config'
import GeoContext from 'contexts/geoContext'
import LuxPlusRenewalBanner from 'luxPlus/components/Banners/LuxPlusRenewalBanner'
import LuxPlusWarningMessageBanner from 'luxPlus/components/Banners/LuxPlusWarningMessageBanner'
import { getHasLuxPlusPendingRenewalBanner } from 'luxPlus/selectors/featureToggle'
import React, { useContext, useRef } from 'react'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import AtolProtectedBanner from './HeaderBanners/AtolProtectedBanner'
import CookiesDisabledWarningBanner from './HeaderBanners/CookiesDisabledWarningBanner'
import { useAppHeaderObserver } from 'hooks/useAppLayoutObservers'
import useCurrentSiteTakeover from 'hooks/useCurrentSiteTakeover'
import SiteTakeoverPageBanner from 'components/Common/SiteTakeover/SiteTakeoverPageBanner'
import { AGENTHUB_SUPPORT_EMAIL } from 'agentHub/constants'
import NotificationBannerV2 from './HeaderBanners/NotificationBannerV2'
import LoyaltyMembershipActivationPageBanner from 'loyalty/components/Banners/LoyaltyMembershipActivationPageBanner'
import getCanLoyaltyEnrollExistingUser from 'loyalty/selectors/getCanLoyaltyEnrollExistingUser'
import { useAppSelector } from 'hooks/reduxHooks'
import WhiteLabelPromoBanner from 'components/WhiteLabel/WhitelLabelPromoBanner'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import NotificationBannerV3 from './HeaderBanners/NotificationBannerV3'

/**
 * Contains all the banners that are meant to be displayed on top of the page.
 */
function HeaderTopBanners() {
  const { currentRegionCode } = useContext(GeoContext)
  const containerRef = useRef<HTMLDivElement>(null)
  useAppHeaderObserver(containerRef)

  const siteTakeover = useCurrentSiteTakeover()
  const canLoyaltyEnrollExistingUser = useAppSelector(getCanLoyaltyEnrollExistingUser)
  const isTargetedBannerV3Enabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.croTargetedBannerV3)
  const subscription = useAppSelector(state => state.auth.account.luxPlus.member.subscription)
  const hasLuxPlusPendingRenewalBanner = useAppSelector(getHasLuxPlusPendingRenewalBanner)

  return <div ref={containerRef}>
    {isTargetedBannerV3Enabled ? <NotificationBannerV3 /> : <NotificationBannerV2 />}
    {subscription.error && <LuxPlusWarningMessageBanner />}
    {hasLuxPlusPendingRenewalBanner && <LuxPlusRenewalBanner />}
    {canLoyaltyEnrollExistingUser && <LoyaltyMembershipActivationPageBanner />}
    {currentRegionCode === 'GB' && <TripGuard>
      <CSSBreakpoint max="mobile">
        <AtolProtectedBanner />
      </CSSBreakpoint>
    </TripGuard>}
    {config.agentHub.isEnabled && <PageBanner
      kind="promotional-primary"
      align="center"
      description={<>Need help? Email <TextLink href={`mailto:${AGENTHUB_SUPPORT_EMAIL}`}>{AGENTHUB_SUPPORT_EMAIL}</TextLink></>}
    />}
    <WhiteLabelPromoBanner />
    <CookiesDisabledWarningBanner />
    {!!siteTakeover && <SiteTakeoverPageBanner />}
  </div>
}

export default HeaderTopBanners
